import { render, staticRenderFns } from "./ListReferrals.vue?vue&type=template&id=7e2746ac"
import script from "./ListReferrals.vue?vue&type=script&lang=ts"
export * from "./ListReferrals.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports